import { useTheme } from '@emotion/react';
import { AlarmClock } from '@icon-park/react';
import { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import dayjs from '@didaskill/services/dayjs';
import { Tooltip, Typography } from '@didaskill/ui/design-system';

import messages from './ReadingTime.messages';
import * as styles from './ReadingTime.styles';

export type ReadingTimeProps = {
  estimatedReadingTime: number;
  withIcon?: boolean;
};

const ReadingTimeBase = ({ estimatedReadingTime, withIcon = false }: ReadingTimeProps) => {
  const { colors } = useTheme();

  const duration = useMemo(() => dayjs.duration(estimatedReadingTime), [estimatedReadingTime]);
  const formattedMinutes = duration.minutes().toString().padStart(2, '0');

  return (
    <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR} css={styles.readingTime}>
      {withIcon ? (
        <Tooltip content={<FormattedMessage {...messages.ESTIMATED_READING_TIME} />}>
          <div>
            <AlarmClock fill={[colors.gray[500], colors.gray[0]]} />
          </div>
        </Tooltip>
      ) : (
        <span>
          <FormattedMessage {...messages.ESTIMATED_READING_TIME} />
        </span>
      )}

      <FormattedMessage
        {...messages.FORMATTED_TIME}
        values={{
          minutes: duration.minutes(),
          hours: duration.hours(),
          formattedMinutes,
        }}
      />
    </Typography>
  );
};

ReadingTimeBase.displayName = 'ReadingTime';

export const ReadingTime = memo(ReadingTimeBase);
